import { Modal } from "../../Modal";
import React, { useMemo, useState } from "react";
import { API } from "../../../../../shared/services";
import { useContactsState } from "../../../contexts";
import { toast } from "react-toastify";
import * as _ from "lodash";
import ShowImages from "./ShowImages";
import { getBase64 } from "modules/app/utils";
import * as S from "./styles";

export default function ImageAttachment({
  replySources,
  answerMessage,
  setAnswerMessage,
}) {
  const { currentContact } = useContactsState();
  const [imageModal, setImageModal] = useState();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState();

  function changeImageModal(event) {
    if (images.length === 30) {
      toast.warning("Não é possível enviar mais de 30 mídias por vez");
      return;
    }

    const allImages = _.filter(event.target.files, function (image) {
      return image.type.includes("image");
    });

    setImages([...images, ...allImages]);

    if (allImages.length > 0) {
      setImageModal(true);
    }
  }

  function removeImage(index) {
    const newImages = images.filter(
      (_value, imageIndex) => imageIndex != index
    );

    setImages(newImages);

    if (newImages.length == 0) {
      setImageModal(false);
      setAnswerMessage(null);
    }
  }

  async function sendImage(image, index, total) {
    try {
      const imageBase64 = await getBase64(image);
      const imageName = image.name;

      await API.post(`/customers/${currentContact.id}/messages`, {
        message: {
          body: imageName,
          message_quoted_id: answerMessage?.id,
          file: {
            data: imageBase64,
            filename: imageName,
          },
        },
        reply_sources: replySources,
      });

      toast.success(
        `Imagem ${parseInt(index) + 1}/${total} enviada com sucesso`
      );
    } catch (e) {
      toast.error(`Imagem ${parseInt(index) + 1}/${total} não foi enviada`);
    }
  }

  async function handleClick() {
    setLoading(true);

    for (const index in images) {
      const image = images[index];
      await sendImage(image, index, images.length);
    }

    setImageModal(false);
    setImages([]);
    setAnswerMessage(null);

    setLoading(false);
  }

  function handleClose() {
    setImages([]);
    setImageModal(false);
  }

  const previews = useMemo(() => {
    return images.length > 0
      ? _.map(images, (image) => URL.createObjectURL(image))
      : [];
  }, [images]);

  return (
    <>
      {imageModal && (
        <Modal
          size="large"
          open={imageModal}
          onClose={handleClose}
          title="Imagens selecionadas"
        >
          <ShowImages
            previews={previews}
            removeImage={removeImage}
            onSubmit={handleClick}
            loading={loading}
            addNewImages={changeImageModal}
          />
        </Modal>
      )}

      <S.ImageButton variant="text" component="label">
        <S.ImageIcon />

        <input
          type="file"
          accept="image/*"
          hidden
          multiple
          onChange={changeImageModal}
        />
      </S.ImageButton>
    </>
  );
}
